export default "__VITE_ASSET__a0ad4927__"